<template>
  <div>
    <div
      v-if="!isAllDataLoaded"
      class="overlay-loading">
      <h2 class="preloader isLoading">Trwa ładowanie</h2>
    </div>
    <d-list-group v-if="isViewLoaded">
      <d-list-group-item class="pb-4">
        <d-row>
          <d-col :md="isDraft ? 5 : 12">
            <d-form v-if="isDraft">
              <d-form-row>
                  <d-col md="6" class="form-group">
                      <label>Nazwa załącznika</label>
                      <ss-input
                          type="text"
                          name="schedule_attachment_name"
                          class="text-left"
                          v-model="schedule.schedule_attachment_name"
                          placeholder=""/>
                  </d-col>
                  <d-col md="6" class="form-group">
                      <label class="w-100">Uwzględnij VAT</label>
                      <d-checkbox
                        inline
                        v-model="vatIncluded"
                        toggle
                        :disabled="!isViewLoaded" />
                  </d-col>
              </d-form-row>
              <d-form-row>
                  <d-col md="6" class="form-group">
                      <label>Kolejność zaliczania wpłat</label>
                      <d-select
                        name="payment_allocation"
                        v-model="schedule.payment_allocation"
                        :disabled="!isDraft">
                        <option value="capital_first">Najpierw kapitał</option>
                        <option value="interest_first">Najpierw koszty i odsetki</option>
                      </d-select>
                  </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Data umowy</label>
                  <ss-date
                    type="text"
                    name="contract_date"
                    v-model="schedule.contract_date"
                    @click="lar_errors.clear('contract_date')"
                    :class="{'is-invalid' : lar_errors.has('contract_date')}"
                    placeholder=""/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('contract_date')">
                  </div>
                </d-col>
                <d-col md="6" class="form-group">
                    <ss-input
                      v-model="schedule.contract_number"
                      name="contract_number"
                      label="Nr umowy"
                      placeholder="Nr umowy">
                    </ss-input>
                </d-col>
              </d-form-row>
              <d-form-row v-if="clientType=== 'corporation'">
                <d-col md="6" class="form-group">
                  <label>Data uchwały na której została wyrażona zgoda na zaciągnięcie zobowiązania</label>
                  <ss-date
                    type="text"
                    name="contract_date"
                    v-model="schedule.client_resolution_date"
                    @click="lar_errors.clear('client_resolution_date')"
                    :class="{'is-invalid' : lar_errors.has('client_resolution_date')}"
                    placeholder=""/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('client_resolution_date')">
                  </div>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Kwota pożyczki dla klienta</label>
                  <ss-price-input
                    type="text"
                    name="loan_amount"
                    v-model="schedule.loan_amount"
                    @input="lar_errors.clear('loan_amount')"
                    :class="{'is-invalid' : lar_errors.has('loan_amount')}"
                    placeholder=""/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('loan_amount')">
                  </div>
                </d-col>
                <d-col md="6" class="form-group">
                  <label>Spółka</label>
                  <d-select
                    type="text"
                    name="company_id"
                    v-model="schedule.company_id"
                    @input="lar_errors.clear('company_id')"
                    :class="{'is-invalid' : lar_errors.has('company_id')}"
                    placeholder="">
                    <option :value="null">--Wybierz spółkę</option>
                    <option
                      v-for="company in allCompanies"
                      :key="company.id"
                      :value="company.id">
                      {{ company.name }}
                    </option>
                  </d-select>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('company_id')">
                  </div>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Odsetki (%)</label>
                  <ss-price-input
                    type="text"
                    name="loan_installment"
                    v-model="schedule.interest_rate"
                    @blur="calculateCapitals"
                    @input="lar_errors.clear('interest_rate')"
                    :class="{'is-invalid' : lar_errors.has('interest_rate')}"
                    placeholder=""/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('interest_rate')">
                  </div>
                </d-col>
                <d-col
                  v-if="schedule.include_vat === 0"
                  md="6"
                  class="form-group">
                  <label>Prowizja (zł)</label>
                  <ss-price-input v-model="schedule.installment_sum" />
                </d-col>
              </d-form-row>
              <d-form-row v-if="schedule.include_vat === 1">
                <d-col
                  md="6"
                  class="form-group">
                  <label>Prowizja netto (zł)</label>
                  <ss-price-input
                    v-model="installment_sum_net"
                    @input="setGrossForValue(installment_sum_net, 'schedule.installment_sum', 'installment_sum', 'input')"
                    :class="{'is-invalid' : lar_errors.has('installment_sum_net')}"
                    :disabled="isValuesSetup || isCalculatingGross || isCalculatingNet"  />
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('installment_sum_net')">
                  </div>
                </d-col>
                <d-col
                  md="6"
                  class="form-group">
                  <label>Prowizja brutto (zł)</label>
                  <ss-price-input
                    v-model="schedule.installment_sum"
                    @input="setNetForValue(schedule.installment_sum, 'installment_sum_net', 'installment_sum_net', 'input')"
                    :disabled="isValuesSetup || isCalculatingGross || isCalculatingNet"
                    :class="{'is-invalid' : lar_errors.has('installment_sum')}" />
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('installment_sum')">
                  </div>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label for="number_of_installments">Liczba rat</label>
                  <input
                    id="number_of_installments"
                    class="form-control"
                    type="text"
                    @blur="rearrangeInstallments"
                    name="number_of_installments"
                    v-model="schedule.number_of_installments"
                    @input="lar_errors.clear('number_of_installments')"
                    :class="{'is-invalid' : lar_errors.has('number_of_installments')}"
                    placeholder="" />
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('number_of_installments')">
                  </div>
                  <d-button
                    class="m-top"
                    @click.prevent="setOptimalInstallmentsNumber">
                    Optymalna liczba rat
                  </d-button>
                </d-col>
                <d-col md="6" class="form-group">
                  <label>Kwota raty</label>
                  <ss-price-input
                    type="text"
                    name="installment_fee"
                    v-model="schedule.installment_fee"
                    @change="lar_errors.clear('installment_fee')"
                    :class="{'is-invalid' : lar_errors.has('installment_fee')}"
                    @blur="installmentFeeChangedHandler"
                    placeholder=""/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('installment_fee')">
                  </div>
                  <d-button
                    class="m-top"
                    @click.prevent="setOptimalInstallmentFee">
                    Optymalna kwota raty
                  </d-button>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label>Kwota z oświadczenia o poddaniu się egzekucji</label>
                  <ss-price-input
                    type="text"
                    name="contract_statement_amount"
                    v-model="schedule.contract_statement_amount"
                    @input="lar_errors.clear('contract_statement_amount')"
                    :class="{'is-invalid' : lar_errors.has('contract_statement_amount')}"
                    placeholder=""/>
                  <div
                    class="invalid-feedback"
                    v-text="lar_errors.get('contract_statement_amount')">
                  </div>
                </d-col>
                <d-col md="6" class="form-group">
                    <label>Data oświadczenia o poddaniu się egzekucji</label>
                    <ss-date
                      type="text"
                      name="contract_statement_date"
                      v-model="schedule.contract_statement_date"
                      @click="lar_errors.clear('contract_statement_date')"
                      :class="{'is-invalid' : lar_errors.has('contract_statement_date')}"
                      placeholder=""/>
                    <div
                      class="invalid-feedback"
                      v-text="lar_errors.get('contract_statement_date')">
                    </div>
                </d-col>
              </d-form-row>
              <d-form-row>
                  <d-col md="12" class="form-group">
                    <ss-input
                      v-model="schedule.contract_statement_doc"
                      name="contract_statement_doc"
                      label="Nr Rep. A"
                      placeholder="Nr aktu notarialnego">
                    </ss-input>
                  </d-col>
                </d-form-row>
                <d-form-row>
                  <d-col
                    v-if="schedule.include_vat === 0"
                    md="12"
                    class="form-group">
                    <label>Koszty monitów:</label>
                    <ss-price-input
                      type="text"
                      name="default_reminder_price"
                      v-model="schedule.default_reminder_price"
                      @input="lar_errors.clear('default_reminder_price')"
                      :class="{'is-invalid' : lar_errors.has('default_reminder_price')}"
                      placeholder=""/>
                    <div
                      class="invalid-feedback"
                      v-text="lar_errors.get('default_reminder_price')">
                    </div>
                  </d-col>
                  <template v-else>
                    <d-col
                      md="6"
                      class="form-group">
                      <label>Koszty monitów (netto):</label>
                      <ss-price-input
                        type="text"
                        name="default_reminder_price_net"
                        v-model="default_reminder_price_net"
                        @input="setGrossForValue(default_reminder_price_net, 'schedule.default_reminder_price', 'default_reminder_price_net', 'input')"
                        :class="{'is-invalid' : lar_errors.has('default_reminder_price_net')}"
                        placeholder=""
                        :disabled="isValuesSetup"/>
                      <div
                        class="invalid-feedback"
                        v-text="lar_errors.get('default_reminder_price_net')">
                      </div>
                    </d-col>
                    <d-col
                      md="6"
                      class="form-group">
                      <label>Koszty monitów (brutto):</label>
                      <ss-price-input
                        type="text"
                        name="default_reminder_price"
                        :value="schedule.default_reminder_price"
                        :class="{'is-invalid' : lar_errors.has('default_reminder_price')}"
                        placeholder=""
                        disabled/>
                      <div
                        class="invalid-feedback"
                        v-text="lar_errors.get('default_reminder_price')">
                      </div>
                    </d-col>
                  </template>
              </d-form-row>
            </d-form>
            <div
              v-if="schedule.close_date || !isDraft"
              class="card-body p-0 pb-3 text-center">
              <div
                v-if="schedule.close_date"
                class="schedule-closed bg-success pt-2 pb-2">
                <p class="text-white mb-0">
                  Umowa została zamknięta z dniem
                  <strong>{{schedule.close_date}}</strong>
                  <br>Stan płatności na ten dzień wynosił
                  <strong>{{ closeAmount }}</strong>
                </p>
              </div>
              <div
                v-if="!isDraft"
                class="contract-info text-left mt-5">
                <d-row>
                  <d-col>
                    <dl>
                      <dt>Spółka:</dt>
                      <dd v-if="!companyById(schedule.company_id)">
                        Spółka została usunięta
                      </dd>
                      <dd v-if="schedule.company_id">
                        <a
                          :href="$router.resolve({ name: 'company-edit', params: { id: schedule.company_id } }).href" target="_blank">
                          {{ companyById(schedule.company_id) }}
                        </a>
                      </dd>
                      <dd v-else>brak</dd>
                    </dl>
                     <dl>
                        <dt>Kary umowne (brutto)</dt>
                        <dd>
                          <ss-price-input
                            name="contract_penalties"
                            class="text-left"
                            v-model="schedule.contract_penalties"
                            :class="{'is-invalid' : lar_errors.has('contract_penalties')}"
                            placeholder="Kary umowne (brutto)"
                            :disabled="isValuesSetup || schedule.status === 'closed'"/>
                          <div class="invalid-feedback" v-text="lar_errors.get('contract_penalties')"></div>
                        </dd>
                    </dl>
                    <template v-if="!!schedule.include_vat">
                      <dl>
                        <dt>Opłata windykacyjna (netto):</dt>
                        <dd>
                          <ss-price-input
                            name="vindication_fee_net"
                            class="text-left"
                            v-model="vindication_fee_net"
                            @input="setGrossForValue(vindication_fee_net, 'schedule.vindication_fee', 'vindication_fee', 'input')"
                            :class="{'is-invalid' : lar_errors.has('vindication_fee_net')}"
                            placeholder="Opłata windykacyjna netto"
                            :disabled="isValuesSetup || schedule.status === 'closed'"/>
                          <div class="invalid-feedback" v-text="lar_errors.get('vindication_fee_net')"></div>
                        </dd>
                      </dl>
                      <dl>
                        <dt>Opłata windykacyjna (brutto):</dt>
                        <dd>
                          <ss-price-input
                            name="vindication_fee"
                            class="text-left"
                            v-model="schedule.vindication_fee"
                            @input="lar_errors.clear('vindication_fee')"
                            :class="{'is-invalid' : lar_errors.has('vindication_fee')}"
                            placeholder="Opłata windykacyjna brutto"
                            disabled/>
                          <div class="invalid-feedback" v-text="lar_errors.get('vindication_fee')"></div>
                        </dd>
                      </dl>
                    </template>
                    <template v-else>
                      <dl>
                        <dt>Opłata windykacyjna:</dt>
                        <dd>
                          <ss-price-input
                            name="vindication_fee"
                            class="text-left"
                            v-model="schedule.vindication_fee"
                            @input="lar_errors.clear('vindication_fee')"
                            :class="{'is-invalid' : lar_errors.has('vindication_fee')}"
                            placeholder="Opłata windykacyjna"
                            :disabled="schedule.status === 'closed'"/>
                          <div class="invalid-feedback" v-text="lar_errors.get('vindication_fee')"></div>
                        </dd>
                      </dl>
                    </template>
                    <dl>
                      <dt>Kolejność zaliczania wpłat:</dt>
                      <dd>
                        {{ schedule.payment_allocation === 'interest_first'
                          ? 'Najpierw koszty i odsetki'
                          : 'Najpierw kapitał' }}
                      </dd>
                    </dl>
                    <dl>
                      <dt>Nazwa załącznika harmonogramu:</dt>
                      <dd>
                          <ss-input
                              type="text"
                              name="schedule_attachment_name"
                              class="text-left"
                              v-model="schedule.schedule_attachment_name"
                              placeholder=""/>
                      </dd>
                    </dl>
                    <dl>
                      <dt>Numer umowy:</dt>
                      <dd>
                        <ss-input
                          type="text"
                          name="contract_number"
                          class="text-left"
                          v-model="schedule.contract_number"
                          placeholder=""/>
                      </dd>
                    </dl>

                    <dl>
                      <dt>Data umowy:</dt>
                      <dd>
                        <ss-date
                          type="text"
                          name="contract_date "
                          v-model="schedule.contract_date"
                          placeholder=""/>
                      </dd>
                    </dl>
                    <dl v-if="clientType === 'corporation'">
                      <dt>Data uchwały na której została wyrażona zgoda na zaciągnięcie zobowiązania:</dt>
                      <dd>
                        <ss-date
                          type="text"
                          name="contract_date "
                          v-model="schedule.client_resolution_date"
                          placeholder=""/>
                      </dd>
                    </dl>

                    <dl>
                      <dt>Spłacono do tej pory:</dt>
                      <dd>{{ toNumber(schedule.paid_amount) }} zł</dd>
                    </dl>
                    <dl v-if="schedule.overpayment > 0">
                      <dt>Nadpłata:</dt>
                      <dd>{{ toNumber(schedule.overpayment) }} zł</dd>
                    </dl>
                    <dl>
                      <dt>Pozostało do spłaty<br />na dzień dzisiejszy:</dt>
                      <dd>
                        {{ toNumber(schedule.to_finish_credit) }} zł
                        <br>
                        <button
                          @click.prevent="$bus.$emit(
                            'view-details',
                            'details_to_finish_credit',
                            schedule.to_finish_credit
                          )"
                          type="button"
                          class="btn btn-link px-0">
                          pokaż szczegóły
                        </button>
                        <div
                          v-if="(nextInstallmentAmount < 1 && amountLeft > 0) || (schedule.terminated_date && amountLeft > 0)"
                          class="date-cell-wrapper"
                          style="min-height: 35px;">
                          <div>
                            <d-button>
                              Dodaj&nbsp;wpłatę
                            </d-button>
                          </div>
                          <ss-date
                            @picked="contractPaid(schedule.to_finish_credit)"
                            type="text"
                            name="terminated-payment-date"
                            v-model="terminatedPaymentDate"
                            placeholder=""/>
                        </div>
                      </dd>
                    </dl>
                    <dl v-if="schedule.to_finish_credit_under_contract > 0">
                      <dt>Pozostało do spłaty<br />według umowy:</dt>
                      <dd>
                        {{ toNumber(schedule.to_finish_credit_under_contract) }} zł
                        <br>
                        <button
                          @click.prevent="$bus.$emit(
                            'view-details',
                            'details_to_finish_credit_under_contract',
                            schedule.to_finish_credit_under_contract
                          )"
                          type="button"
                          class="btn btn-link px-0">
                          pokaż szczegóły
                        </button>
                      </dd>
                    </dl>
                    <dl v-if="!schedule.terminated_date && nextInstallmentAmount > 0">
                      <dt>Data najbliższej raty:</dt>
                      <dd :class="{'text-danger' : nextInstallmentDue}">
                        {{ nextInstallmentDate.substring(0, 10) }}
                      </dd>
                    </dl>
                    <dl v-if="!schedule.terminated_date && nextInstallmentAmount > 0">
                      <dt>Kwota najbliższej raty:</dt>
                      <dd>
                        {{ toNumber(nextInstallmentAmount) }} zł
                        <div class="date-cell-wrapper" style="min-height: 35px;">
                          <div class="wsnw">
                            <d-button>
                              <i class="material-icons">add</i> Dodaj&nbsp;wpłatę
                            </d-button>
                          </div>
                          <ss-date
                            @picked="contractPaid(nextInstallmentAmount)"
                            type="text"
                            name="terminated-payment-date"
                            v-model="terminatedPaymentDate"
                            placeholder=""/>
                        </div>
                      </dd>
                    </dl>
                  </d-col>
                  <d-col>
                    <dl v-if="schedule.contract_statement_amount > 0">
                      <dt>Kwota z&nbsp;oświadczenia o&nbsp;poddaniu się&nbsp;egzekucji:</dt>
                      <dd>
                        {{ toNumber(schedule.contract_statement_amount) }} zł
                      </dd>
                    </dl>
                    <dl v-if="schedule.contract_statement_date && schedule.contract_statement_date !== '0000-00-00'">
                      <dt>Data oświadczenia o poddaniu się egzekucji:</dt>
                      <dd>
                        {{ schedule.contract_statement_date }}
                      </dd>
                    </dl>
                    <dl v-if="schedule.contract_statement_doc">
                      <dt>Nr Rep. A:</dt>
                      <dd>
                        {{ schedule.contract_statement_doc }}
                      </dd>
                    </dl>
                  </d-col>
                </d-row>
              </div>
            </div>

            <div class="form-group">
              <ss-textarea
                name="loan_purpose"
                v-model="schedule.loan_purpose"
                label="Cel pożyczki"
                placeholder="Opis...">
              </ss-textarea>
            </div>

            <div class="form-group">
              <d-checkbox
                :value="'1'"
                :unchecked-value="'0'"
                toggle
                v-model="schedule.invoices_docs_required">
                Wymagane dostarczenie faktur/dokumentów potwierdzających wydatkowanie środków uzyskanych z pożyczki na cele wskazane w §1 Umowy Pożyczki.
              </d-checkbox>
            </div>
            <div class="d-flex">
              <div
                v-if="schedule.invoices_docs_required == 1"
                class="date-cell-wrapper date-button text-left"
                style="min-height: 35px;min-width: 150px;">
                <div>
                  <d-button
                    :theme="schedule.invoices_docs_delivered_at ? 'success' : 'primary'">
                    Dostarczono&nbsp;dokumenty
                  </d-button>
                </div>
                <ss-date
                  type="text"
                  name="invoices_docs_delivered_at"
                  v-model="schedule.invoices_docs_delivered_at"
                  placeholder=""/>
              </div>
              <div
                v-if="schedule.invoices_docs_delivered_at"
                class="ml-4">
                Dokumenty dostarczono dnia: <strong>{{ schedule.invoices_docs_delivered_at}}</strong>
              </div>
            </div>
            <ss-textarea
              v-model="schedule.comments"
              name="comments"
              label="Komentarze"
              placeholder="Opis...">
            </ss-textarea>
          </d-col>
          <d-col md="7" v-if="isDraft">
            <d-card-header class="border-0 flex-header">
              <h6 class="m-0">Harmonogram rat</h6>
              <d-button
                class="ml-3"
                :class="{ isLoading: exportInProgress }"
                theme="success"
                @click.prevent="exportToPdf">
                Exportuj do PDF
              </d-button>
            </d-card-header>
            <d-list-group-item class="text-center pl-0 pr-0">
              <table class="table mb-0" style="border: 1px #dee2e6 solid;table-layout: fixed;">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0 col-id">#</th>
                    <th scope="col" class="border-0">Data płatności</th>
                    <th scope="col" class="border-0">Rata</th>
                    <th scope="col" class="border-0">Kapitał</th>
                    <th scope="col" class="border-0">Odsetki</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(installment, index) in schedule.installments"
                    :class="{ red : rowThemeDanger(installment)}"
                    :key="index"
                  >
                    <td>{{ (parseInt(index) + 1) }}</td>
                    <td>
                      <ss-date
                        type="text"
                        name="payment_date"
                        v-model="installment.payment_date"
                        @click="lar_errors.clear('payment_date')"
                        :limitfrom="getLimitFrom(index)"
                        :limitto="getLimitTo(index)"
                        :class="{'is-invalid' : lar_errors.has('payment_date')}"
                        placeholder=""/>
                      <div
                        class="invalid-feedback"
                        v-text="lar_errors.get('payment_date')">
                      </div>
                    </td>
                    <td>
                      <ss-price-input
                        v-if="index < schedule.installments.length -1"
                        :readonly="index > schedule.installments.length -2"
                        type="text"
                        name="installment_fee"
                        v-model="installment.installment_fee"
                        @blur="singleInstallmentChanged"
                        placeholder=""/>
                      <ss-price-input
                        v-else
                        :readonly="true"
                        type="text"
                        name="installment_fee"
                        :value="lastInstallment" />
                    </td>
                    <td>{{ toNumber(installment.capital) }} zł</td>
                    <td :class="{ 'is-loading': interestsLoading }">
                      {{ toNumber(installment.interest) }}zł
                    </td>
                  </tr>
                </tbody>
              </table>
            </d-list-group-item>
          </d-col>
        </d-row>
      </d-list-group-item>

      <paid-installment-modal
        v-if="isPaidInstallmentModalVisible"
        :amount-prop="amount"
        :is-modal-visible="isPaidInstallmentModalVisible"
        :scheduleId="schedule.id"
        :terminated-payment-date="terminatedPaymentDate" />
    </d-list-group>
  </div>
</template>

<script>
import LarErrors from '@/helpers/Errors';
import SsDate from '@/components/common/SsDate';
import SsTextarea from '@/components/common/SsTextarea';
import SsPriceInput from '@/components/common/SsPriceInput';
import PaidInstallmentModal from '@/components/client/contract-partials/basic-info/PaidInstallmentModal.vue';
import CommonUtils from '@/utils/CommonUtils';
import FormUtils from '@/utils/FormUtils';

export default {
  name: 'ContractBasicInfoData',
  components: {
    LarErrors,
    SsDate,
    SsTextarea,
    SsPriceInput,
    PaidInstallmentModal
  },
  props: {
    allCompanies: {
      type: Array,
      default: () => []
    },
    clientType: {
      type: String,
      required: true
    },
    exportInProgress: {
      default: false,
      type: Boolean
    },
    isDraft: {
      type: Boolean,
      required: true
    },
    interestsLoading: {
      default: false,
      type: Boolean
    },
    lastInstallment: {
      type: Number,
      default: 0
    },
    scheduleProp: {
      type: Object,
      required: true
    }
  },
  computed: {
    isAllDataLoaded () {
      return this.isViewLoaded && !this.isValuesSetup;
    },
    amountLeft () {
      return this.schedule.to_finish_credit;
    },
    closeAmount(){
      let _text = this.toNumber(this.schedule.close_amount) + ' zł';
      if(this.schedule.close_amount !== 0){
          _text += ' (' + (this.toNumber(this.schedule.close_amount).indexOf('-') >= 0 ? 'niedopłata' : 'nadpłata') + ')'
      }
      return _text;
    },
    nextInstallment(){
      return this.schedule.installments.find(x => x.is_paid === 0);
    },
    nextInstallmentDate(){
      return this.nextInstallment ? this.nextInstallment.payment_date : 'Wszystkie raty zostały opłacone';
    },
    nextInstallmentDue(){
      return this.nextInstallmentDate < Vue.getCurrentDate();
    },
    nextInstallmentAmount(){
      if (this.nextInstallment) {
        if (this.nextInstallment.last_installment_fee_with_interest) {
          return this.nextInstallment.last_installment_fee_with_interest;
        } else {
          return this.nextInstallment.installment_fee - this.nextInstallment.amount_paid;
        }
      }
      return '0';
    },
    firstPaymentDate(){
      return new Date(this.schedule.first_installment_date);
    }
  },
  watch: {
    async vatIncluded (newValue) {
      this.schedule.include_vat = newValue ? 1 : 0;

      if (!this.isViewLoaded) {
        return;
      }

      if (newValue) {
        if (this.isDraft) {
          Vue.set(this, 'isValuesSetup', true);
          // we calculate only installment_sum and default_reminder_price.
          // vindication_fee is used for NOT draft contracts

          // only installment_sum_net should be based on schedule.installment_sum
          Vue.set(this, 'installment_sum_net', this.schedule.installment_sum);
          await this.setGrossForValue(this.installment_sum_net, 'schedule.installment_sum', 'installment_sum');
          await this.$nextTick();

          await this.setNetForValue(this.schedule.default_reminder_price, 'default_reminder_price_net', 'default_reminder_price_net');
          await this.$nextTick();
          Vue.set(this, 'isValuesSetup', false);
        } else {
          // this condition is just in case. vatIncluded toggle should be enabled only for draft contracts
          await this.recalculateNet();
        }
      } else {
        if (this.isDraft) {
          // when draft and switch to contract without VAT installment_sum should be set to installment_sum_net
          Vue.set(this.schedule, 'installment_sum', this.installment_sum_net);
        }
      }
      this.$bus.$emit('contract-get-interests');
    }
  },
  data () {
    return {
      amount: 0,
      default_reminder_price_net: 0,
      installment_sum_net: 0,
      isCalculatingGross: false,
      isCalculatingNet: false,
      isPaidInstallmentModalVisible: false,
      isValuesSetup: false,
      isViewLoaded: false,
      lar_errors: LarErrors,
      schedule: null,
      terminatedPaymentDate: null,
      vatIncluded: false,
      vindication_fee_net: 0
    }
  },
  mounted() {
    this.schedule = this.scheduleProp;
    this.vatIncluded = this.schedule.include_vat === 0 ? false : true;
    this.$bus.$on('paid-installment-close', this.closePaidInstallmentModal);

    this.$nextTick(() => {
      this.recalculateNet();

      this.isViewLoaded = true;
    })
  },
  methods: {
    contractPaid (sum) {
      if (sum) {
        Vue.set(this, 'amount', sum);
      }
      this.$nextTick(() => {
        this.isPaidInstallmentModalVisible = true;
      })
    },
    async setGrossForValue (value, fieldPath, errorFieldName, callbackSource) {
      if (this.isValuesSetup && callbackSource === 'input') {
        return;
      }

      if (callbackSource === 'input' && (this.isCalculatingNet || this.isCalculatingGross)) {
        return;
      }

      this.isCalculatingGross = true;

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        this.$nextTick(function () {
          this.isCalculatingGross = false;
        });
        return;
      }

      let { value: grossValue, isError} = await FormUtils.getGrossValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          this.$nextTick(function () {
            this.isCalculatingGross = false;
          });
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
      this.$nextTick(function () {
        this.isCalculatingGross = false;
      });
    },
    async setNetForValue (value, fieldPath, errorFieldName, callbackSource) {
      if (this.isValuesSetup && callbackSource === 'input') {
        return;
      }

      if (callbackSource === 'input' && (this.isCalculatingNet || this.isCalculatingGross)) {
        return;
      }

      this.isCalculatingNet = true;

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        this.$nextTick(function () {
          this.isCalculatingNet = false;
        });
        return;
      }

      let { value: netValue, isError} = await FormUtils.getNetValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          this.$nextTick(function () {
            this.isCalculatingNet = false;
          });
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, netValue);
      this.$nextTick(function () {
        this.isCalculatingNet = false;
      });
    },
    async recalculateNet () {
      if (!this.schedule.include_vat) {
        return;
      }
      Vue.set(this, 'isValuesSetup', true);

      if (this.isDraft) {
        await this.setNetForValue(this.schedule.installment_sum, 'installment_sum_net', 'installment_sum_net');
      } else {
        await this.setNetForValue(this.schedule.vindication_fee, 'vindication_fee_net', 'vindication_fee_net');
      }

      await this.setNetForValue(this.schedule.default_reminder_price, 'default_reminder_price_net', 'default_reminder_price_net');

      await this.$nextTick()
      Vue.set(this, 'isValuesSetup', false);
    },
    closePaidInstallmentModal () {
      this.$nextTick(() => {
        this.isPaidInstallmentModalVisible = false;
      })
    },
    toNumber (number) {
      return Vue.toNumber(number);
    },
    exportToPdf () {
      this.$bus.$emit('contract-schedule-export-pdf');
    },
    companyById (id) {
      let company = this.allCompanies.length > 0 ? this.allCompanies.find(x => x.id === id) : this.allCompanies.length;
      return company ? company.name : '';
    },
    calculateCapitals () {
      this.$bus.$emit('contract-calculate-capitals');
    },
    installmentFeeChangedHandler () {
      for (let i = 0; i < this.schedule.installments.length; i++) {
        this.schedule.installments[i].installment_fee = this.schedule.installment_fee;
      }
      this.calculateCapitals();
    },
    rowThemeDanger (inst) {
      inst = inst.last_installment_fee_with_interest ? this.lastInstallment : inst;
      return inst.capital < 0 || (inst.capital === 0 && inst.installment_fee === 0);
    },
    getLimitFrom (index) {
      return index < 2 ? this.schedule.first_installment_date : this.schedule.installments[(index - 1)].payment_date;
    },
    getLimitTo (index) {
      return index < (this.schedule.installments.length - 1) ? this.schedule.installments[(index + 1)].payment_date: '';
    },
    singleInstallmentChanged () {
      this.calculateCapitals();
    },
    rearrangeInstallments(event, generate) {
      let to = event.target ? event.target.value : event;
      let from = parseInt(this.schedule.installments.length);

      if (to > from) {
        let new_installments = [];
        for (let i = from; i < to; i++) {
          new_installments.push({
            interest_penalty: 0,
            installment_fee: this.schedule.installment_fee,
            payment_date: ''
          })
        }
        this.schedule.installments = [...this.schedule.installments, ...new_installments];
        this.generatePaymentDates();
        this.$nextTick(() => {
          this.calculateCapitals();
        })
      }
      if (from > to) {
        for(let i = 0; i < from - to; i++){
          this.schedule.installments.pop();
        }
        this.calculateCapitals();
      }
      if (generate) {
        this.$nextTick(() => {
          this.generateTable();
        })
      }

      this.$bus.$emit('contract-get-interests');
    },
    generatePaymentDates(){
      for (let i = 0; i < this.schedule.number_of_installments; i++) {
        if (!this.schedule.installments[i]) return false;
        this.schedule.installments[i].payment_date = this.nextDate(i);
      }
    },
    nextDate (i) {
      switch(this.schedule.installment_frequency){
      case 1:
        return this.nextWeekDate(i*2);
        break;
      case 2:
        return this.nextMonthDate(i);
        break;
      case 3:
        return this.nextMonthDate(i*2);
        break;
      case 4:
        return this.nextMonthDate(i*3);
        break;
      case 5:
        return this.nextWeekDate(i);
        break;
      }
    },
    nextWeekDate (i) {
      let nextWeek = new Date(
      this.firstPaymentDate.getFullYear(),
      this.firstPaymentDate.getMonth(),
      this.firstPaymentDate.getDate()+7*i );
      return this.dateFormat(nextWeek);
    },
    nextMonthDate(i){
      let nextWeek = new Date(
      this.firstPaymentDate.getFullYear(),
      this.firstPaymentDate.getMonth() + i,
      this.firstPaymentDate.getDate() );
      return this.dateFormat(nextWeek);
    },
    setOptimalInstallmentsNumber(){
      this.schedule.number_of_installments = Math.floor(this.schedule.loan_installment_sum/this.schedule.installment_fee);

      this.rearrangeInstallments(this.schedule.number_of_installments, true);
    },
    generateTable(){
      for (let i = 0; i < this.schedule.number_of_installments; i++) {
        this.schedule.installments[i].installment_fee = this.schedule.installment_fee
      }
      this.$nextTick(() => {
        this.calculateCapitals();
      })
    },
    setOptimalInstallmentFee () {
      this.schedule.installment_fee = Math.floor(this.schedule.loan_installment_sum/this.schedule.number_of_installments);
      this.installmentFeeChangedHandler();
    },
    dateFormat (d) {
      let dy = d.getFullYear();
      let dm = (d.getMonth()+1) < 10 ? '0' + (d.getMonth()+1) : (d.getMonth()+1);
      let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();

      return dy + '-' + dm + '-' + dd;
    }
  },
  beforeDestroy () {
    this.$bus.$off('paid-installment-close', this.closePaidInstallmentModal);
  }
}
</script>
